import type { ThemeConfig } from 'antd'

/** 全站 Ant Design 主题与字体，仅在 main.tsx 引用 */
export const appTheme: ThemeConfig = {
  token: {
    colorPrimary: '#2563eb',
    colorBgLayout: '#eef1f6',
    colorBorderSecondary: '#e2e8f0',
    borderRadius: 6,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'PingFang SC', 'Microsoft YaHei', sans-serif",
    fontSize: 14,
  },
  components: {
    Table: { cellFontSize: 14 },
    Form: { labelFontSize: 14 },
    Layout: {
      siderBg: '#0f172a',
      headerBg: '#ffffff',
      bodyBg: '#eef1f6',
    },
  },
}
